import { AgentStatus } from '@/types';
import { AGENT_STATUS_ICONS, AGENT_STATUS_COLORS } from '@/lib/constants';

interface AgentStatusIndicatorProps {
  status: AgentStatus;
  agentName: string;
}

export function AgentStatusIndicator({ status, agentName }: AgentStatusIndicatorProps) {
  return (
    <div className="flex items-center space-x-2">
      <span className={`text-lg ${AGENT_STATUS_COLORS[status]}`}>
        {AGENT_STATUS_ICONS[status]}
      </span>
      <span className="text-sm font-medium text-foreground">
        {agentName} ({status})
      </span>
    </div>
  );
}
